module.exports = "https://cdn.redage.net/src/views/player/documets/fibbadge/images/fib_logo.png";